<template>
    <yams-template>
        <template #header>
            <div class="mr-5">
                <h4 class="text-primary font-weight-bold">Ressources Humaines ({{ lines }})</h4>
            </div>
            <div class="btn-group page-nav mr-4" role="group" aria-label="Basic example">
                <button type="button" class="btn " @click.prevent="changeAffichage('table')"
                    :class="{ 'active': affichage === 'table' }">
                    <i class="fa-solid fa-bars"></i>
                </button>
                <button type="button" class="btn " @click.prevent="changeAffichage('card')"
                    :class="{ 'active': affichage === 'card' }">
                    <i class="fa-solid fa-border-all"></i>
                </button>
            </div>

            <div class="px-1">
                <button class="btn-yams btn-active" type="button" @click="openFormUtilisateurModal">
                    Ajouter un utilisateur <i class="fa fa-plus"></i>
                </button>
            </div>
        </template>
        <template #content>
            <div class="row mb-2">
            <div class="col-md-4 d-flex align-items-center">
                <div class="input-group">
                    <select class="form-control" v-model="selectedType" @change="applyTypeFilter">
                        <option value="">Tous les utilisateurs</option>
                        <option value="transporteur">Entreprise</option>
                        <option value="camionneur">Camionneur</option>
                        <option value="coursier">Coursier</option>
                        <option value="client">Client</option>
                        <option value="agent">Agent controleur</option>
                    </select>
                    <div class="input-group-append">
                        <button class="btn btn-outline-secondary rounded" type="button" @click="resetFilter">
                            <i class="fa fa-close"></i> Reinitialiser
                        </button>
                    </div>
                </div>
            </div></div>
            <div class="card mb-5">
                <div class="card-body p-1">
                    <DataTableBackend :key="key" :url="apiUrl" :view-mode="affichage" :columns="columns" :table="table"
                         @row-click="openShowModal" @set-selected-rows="getSelection"
                        @set-total-records="updateLines">
                        <template #type="slotProps">
                            {{ slotProps.data.type }} <span class="rounded-pill badge" v-if="slotProps.data.sous_type">(
                                {{
                                    slotProps.data.sous_type }} ) </span>
                        </template>
                    </DataTableBackend>
                </div>
            </div>
        </template>
    </yams-template>
</template>

<script>
import { defineComponent, defineAsyncComponent } from 'vue';
const ShowUtilisateur = defineAsyncComponent(() => import('@/views/ressources-humaines/ShowUtilisateur.vue'));
const FormUtilisateur = defineAsyncComponent(() => import('@/views/ressources-humaines/FormUtilisateur.vue'));

export default defineComponent({
    data() {
        return {
            key: 1,
            lines: 0,
            isLoading: false,
            table: 'utilisateurs',
            affichage: "table",
            selection: [],
            selectedType: '',  // Pour stocker le type d'utilisateur sélectionné
            apiUrl: this.$store.getters.apiUrl + '/api/utilisateurs',  // URL de base
            columns: [
                {
                    key: 'name',
                    label: 'Identifiant',
                    exportable: true,
                    sortable: true
                },
                {
                    key: 'type',
                    label: 'Type',
                    exportable: true,
                    sortable: true
                },
                {
                    key: 'nom',
                    label: 'Nom / Raison sociale',
                    exportable: true,
                    sortable: true
                },
                {
                    key: 'email',
                    label: 'Email',
                    exportable: true
                },
                {
                    key: 'telephone1',
                    label: 'Telephone',
                    exportable: true
                }
            ]
        }
    },
    methods: {
        applyTypeFilter() {
            if (this.selectedType) {
                this.apiUrl = `${this.$store.getters.apiUrl}/api/utilisateurs?type=${this.selectedType}`;
            } else {
                this.apiUrl = `${this.$store.getters.apiUrl}/api/utilisateurs`;
            }
            this.key++; // Forcer la réactualisation du composant DataTableBackend
        },
        resetFilter() {
            this.selectedType = '';
            this.apiUrl = `${this.$store.getters.apiUrl}/api/utilisateurs`;
            this.key++;
        },
        openShowModal(objData) {
            this.$dialog.open(ShowUtilisateur, {
                props: {
                    header: "Utilisateur " + objData.name,
                    style: {
                        width: "50vw"
                    },
                    modal: true
                },
                data: objData
            });
        },
        openFormUtilisateurModal() {
            this.$dialog.open(FormUtilisateur, {
                onClose: (returnedType) => {
                    if (returnedType) {
                        // Si un type est retourné par le modal, mettre à jour le filtre
                        this.selectedType = returnedType;
                        this.applyTypeFilter();
                    }
                },
                props: {
                    header: "Nouvel utilisateur",
                    style: {
                        width: '50vw'
                    },
                    modal: true,
                    filteredType: this.selectedType // Passer le type sélectionné au formulaire
                }
            });
        },
        changeAffichage(type) {
            this.affichage = type;
            this.key++
        },
        getSelection(selection) {
            this.selection = selection
        },
        updateLines(nb_lines) {
            this.lines = nb_lines
        }
    }
})
</script>